import { render, staticRenderFns } from "./Vapplicant.vue?vue&type=template&id=3701ad18"
import script from "./Vapplicant.vue?vue&type=script&lang=js"
export * from "./Vapplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports